var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.5654 54.2166L69.9172 40.6174C70.5046 37.2208 67.8925 34.1141 64.4492 34.1141H47.1789C45.4673 34.1141 44.1638 32.5777 44.4409 30.8867L46.6498 17.4048C47.0087 15.2146 46.9062 12.9734 46.3489 10.8252C45.8873 9.04555 44.5142 7.61658 42.7085 7.0365L42.2253 6.88126C41.134 6.53068 39.9429 6.61226 38.914 7.10806C37.7815 7.65379 36.9529 8.6492 36.6458 9.83304L35.0601 15.9459C34.5556 17.8909 33.8207 19.7683 32.8731 21.5421C31.4886 24.134 29.348 26.2083 27.1229 28.1257L22.3271 32.2584C20.9749 33.4236 20.2648 35.1686 20.4187 36.9481L23.1259 68.257C23.3742 71.1288 25.7752 73.3334 28.6545 73.3334H44.1499C55.7542 73.3334 65.6576 65.2481 67.5654 54.2166Z",
    fill: "#314064"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.89222 31.6169C11.2298 31.5591 12.3754 32.5654 12.4907 33.8992L15.7294 71.3542C15.9374 73.7602 14.0423 75.8339 11.6224 75.8339C9.34297 75.8339 7.5 73.9847 7.5 71.7097V34.1145C7.5 32.7757 8.55467 31.6746 9.89222 31.6169Z",
    fill: "#314064"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/Like.91c629a7101fc164caa6eea381710c91.svg";
export { ForwardRef as ReactComponent };